import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import Spinner from '../Spinner';
import { toJS } from 'mobx';
@inject('inventoryProductStore', 'inventoryPcategoryStore', 'inventoryManufacturerStore', 'inventorySupplierStore')
@observer
class InventoryProduct extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { inventoryProductStore, inventoryPcategoryStore,inventoryManufacturerStore, inventorySupplierStore } = this.props;

   if (!inventoryProductStore.isLoading && !inventoryProductStore.length ) inventoryProductStore.fetchItems();
   if (!inventoryPcategoryStore.isLoading && !inventoryPcategoryStore.length ) inventoryPcategoryStore.fetchItems();
   if (!inventoryManufacturerStore.isLoading && !inventoryManufacturerStore.length ) inventoryManufacturerStore.fetchItems();
   if (!inventorySupplierStore.isLoading && !inventorySupplierStore.length ) inventorySupplierStore.fetchItems();
  }

  handleDelete(idOrIds) {
    const { notify } = this.context;
    this.props.inventoryProductStore.removeItems(idOrIds)
      .then(notify.success)
      .catch(notify.error);
  }

  render() {
    const { inventoryProductStore, children, main,inventoryPcategoryStore,inventoryManufacturerStore, inventorySupplierStore  } = this.props;
    if (inventoryProductStore.isLoading || inventoryPcategoryStore.isLoading || inventoryManufacturerStore.isLoading || inventorySupplierStore.isLoading) return <Spinner />;

    let actions = [
      { label: 'View', link: '/inventory/product/{id}/files' },
    ];

    const data = inventoryProductStore.items.map(item => {
      return Object.assign({}, item, {
        pcategory: inventoryPcategoryStore.findById(item.pcategory_id),
        supplier: inventorySupplierStore.findById(item.supplier_id),
        manufacturer: inventoryManufacturerStore.findById(item.manufacturer_id),
      })
    })

    if (!main) {
      return (
        <div>
          <DataTable
            data={data}
            slug={'inventory/product'}
            columns={[
              { key: 'id', label: 'ID' },
              { key: 'name', label: 'Name', searchable: true },
              { key: 'code', label: 'Code', searchable: true },
              { key: 'pcategory.name', label: 'Product Category', searchable: true },
              { key: 'supplier.name', label: 'Supplier', searchable: true },
              { key: 'manufacturer.name', label: 'Manufacturer', searchable: true },
            ]}
            onDelete={this.handleDelete}
            allowAdd
            allowEdit
            allowDelete
            actions={actions}
            resource='inventory'
          />
          {children}
        </div>
      );
    } else {
      return (
        <div className='inline-grid'>
          <div className='side-table'>
            <DataTable
              data={inventoryProductStore.items}
              slug={'inventory/product'}
              columns={[
                { key: 'name', label: 'Name' },
              ]}
              actions={actions}
            />
          </div>
          <div className='flex-grow'>
            {main}
          </div>
        </div>
      )
    }
  }
}

export default InventoryProduct;



// WEBPACK FOOTER //
// ./src/components/Inventory/ProductList.js